import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const generateContentBlockWidgetInputSchema_ = z.object({});

export const generateContentBlockWidget = {
  name: "generateContentBlockWidget" as const,
  input: generateContentBlockWidgetInputSchema_,
  output: zExt.objectId(),
};
